import React, {useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import Style from "../Style.module.css";
import PageTips from "../PageTips";
import * as UserService from "../../api/UserService";
import * as PaymentService from "../../api/PaymentsService"
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import {useTranslation} from "react-i18next";
import {baseUrl} from "../../api/ApiUtils";
import MentorCabinetTransactionsDismisWarning from "./MentorCabinetTransactionsDismisWarning";

function MentorCabinetTransactions(props) {

    const [paymentInitiated, setPaymentInitiated] = useState(false)
    const [topUpAmountSelected, setTopUpAmountSelected] = useState(10)
    const [currentBalance, setCurrentBalance] = useState(0)
    const [transactions, setTransactions] = useState([])
    const [transactionsPullError, setTransactionsPullError] = useState(undefined)
    const [paymentError, setPaymentError] = useState(undefined)
    const [payButtonDisabled, setPayButtonDisabled] = useState(false)
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'payments' });
    const [bonusDismissRequested, setBonusDismissRequested] = useState(false)

    function formatDateTime(datetime) {
        if (!datetime) {
            return ""
        }
        const d = datetime.split("T")[0]
        const t = datetime.split("T")[1].split(":")[0] + ":" + datetime.split("T")[1].split(":")[1]

        return d + " " + t
    }

    function pullCurrentBalance() {
        PaymentService.getCurrentBalance((jres) => {
            setCurrentBalance(jres.balance)
        }, () => {})
    }

    function pullTransaction() {
        PaymentService.getAllPaymentTransactions(
            (r) => {
                setTransactions(r)
            },
            (response) => {
                if (response.url === baseUrl + "logout/") {
                    props.onUnathorized(true)
                } else {
                    setTransactionsPullError(t('transactionsPullError'))
                }
            }
        )
    }

    function startPayment() {
        if (payButtonDisabled) {
            return
        }
        setPayButtonDisabled(true)
        UserService.createCheckoutSession(topUpAmountSelected,
            (data) => {
                window.open(data.session_url, "_self")
            },
            (response) => {
                if (response.url === baseUrl + "logout/") {
                    props.onUnathorized(true)
                } else {
                    setPaymentError(t('paymentError'))
                }

            }
        )
        trySetTimeout(() => setPayButtonDisabled(false), 10000)
    }

    function formatTxnDate(date) {
        const sp = date.split("T")

        const d = sp[0]
        const t = sp[1].split(".")[0]
        return d + " " + t
    }

    function resolveTxnType(type) {
        if (type === "coin_top_up") {
            return t('topUp')
        } else if (type === "coin_charge") {
            return t('payment')
        } else if (type === "coin_refund") {
            return t('chargeBack')
        } else {
            return t('unknown')
        }
    }

    function resolveTxnDescription(txn) {
        if (txn.ref_type === "game") {
            if (txn.game_player_name) {
                return txn.game_name + " [" + txn.game_player_name + "]"
            } else {
                return txn.game_name
            }
        } else {
            return ""
        }
    }

    function completelyDismisBonus(){
        UserService.dismissRefBonus(props.pullMentorData, props.pullMentorData)
        setBonusDismissRequested(false)
    }


    useEffectOnce(() => {
        pullCurrentBalance()
        pullTransaction()
    }, []);

    return (
        <>
            {/*<Banner></Banner>*/}
            <div className={cabinetStyle.mainPageContainer}>
                <PageTips headerText={t('paymentsHeader')}>
                    <div className={Style.h5Heading}>{t('header')}</div>
                    <div>
                        {t('details')} <a href={i18n.language === "en" ? "/price_en" : "/price"}
                                          target="_blank">{t('price')}</a>.
                    </div>
                    {props.pendingRefBenefit && Object.keys(props.pendingRefBenefit).length !== 0  && <div className={Style.pageTipsImportantNote} style={{display: "flex", flexDirection: "column"}}>
                        {t('referralBonus')}
                    <br/>
                        {t('referralBonusNav')}
                        <br/>
                        {t('bonus waiting for you')}
                        <br/>
                        {props.pendingRefBenefit.days && <> {props.pendingRefBenefit.days + t('bonus days')}</>}
                        <br/>
                        {props.pendingRefBenefit.coins && <> {props.pendingRefBenefit.coins + t('bonus coins')} </>}
                        <div className={Style.dismissRefBonusButton} onClick={() => setBonusDismissRequested(true)}>{t('referralBonusDismiss')}</div>
                    </div>}
                    {props.freeTier && <div className={Style.pageTipsImportantNote}>
                        {t('freeUseBefore')} {formatDateTime(props.freeTier)}
                        <br/>
                        {t('supportUs')}</div>}

                </PageTips>
                {bonusDismissRequested && <MentorCabinetTransactionsDismisWarning
                    closeModal={()=> setBonusDismissRequested(false)}
                    onConfirm={completelyDismisBonus}
                    days={props.pendingRefBenefit.days}
                    coins={props.pendingRefBenefit.coins}
                />}
                <div>
                    <div className={`${cabinetStyle.commonTile} ${cabinetStyle.transactionContainer}`}>
                        <header className={Style.h5Heading}>{t('balance')} {currentBalance}
                            <div className={cabinetStyle.coinSmall}/>
                            <div className={cabinetStyle.topUpButton}
                                 onClick={() => {
                                     setPaymentInitiated(!paymentInitiated)
                                     setPaymentError(undefined)
                                 }
                                 }>{paymentInitiated ? t('closeButton') : t('topUpButton')}</div>
                        </header>
                        {paymentInitiated &&
                            <>
                                <div className={cabinetStyle.amountSelector}>
                                    <div
                                        className={topUpAmountSelected === 10 ? cabinetStyle.amountSelectorItemSelected : cabinetStyle.amountSelectorItem}
                                        onClick={() => setTopUpAmountSelected(10)}>10 <div
                                        className={cabinetStyle.coinSmall}/></div>
                                    <div
                                        className={topUpAmountSelected === 50 ? cabinetStyle.amountSelectorItemSelected : cabinetStyle.amountSelectorItem}
                                        onClick={() => setTopUpAmountSelected(50)}>50 <sup>+1 </sup>
                                        <div className={cabinetStyle.coinSmall}/>
                                    </div>
                                    <div
                                        className={topUpAmountSelected === 100 ? cabinetStyle.amountSelectorItemSelected : cabinetStyle.amountSelectorItem}
                                        onClick={() => setTopUpAmountSelected(100)}>100 <sup>+3 </sup>
                                        <div className={cabinetStyle.coinSmall}/>
                                    </div>
                                </div>
                                <div className={payButtonDisabled ? cabinetStyle.topUpButtonDisabled : cabinetStyle.topUpButton} onClick={startPayment}>{t('topUpText')}</div>
                                {paymentError && <div className={cabinetStyle.paymentErrorMessage}>{paymentError}</div>}
                            </>
                        }

                    </div>
                    <div className={cabinetStyle.transactionsBlock}>
                        <div className={`${Style.pageTipsHeader} ${Style.h5Heading}`}>
                            <div>{t('transactions')}</div>
                        </div>
                        <div className={cabinetStyle.transactionsTableContainer}>
                            {transactionsPullError &&
                                <span style = {{padding: "12px"}}>{transactionsPullError}</span>
                            }
                            {
                                transactions.length === 0 && !transactionsPullError &&
                                <span style = {{padding: "12px"}}>{t('noTransactions')}</span>
                            }

                            <table className={cabinetStyle.transactionsTable}>
                                <tbody>
                                    {transactions.map((transaction) => {
                                        return <tr key={transaction.id} className={cabinetStyle.transactionRow}>
                                            <td className={cabinetStyle.transactionDateCell}>
                                                <div>{formatTxnDate(transaction.created).split(" ")[0]}</div>
                                                <div
                                                    style={{fontSize: "12px"}}>{formatTxnDate(transaction.created).split(" ")[1]}</div>

                                            </td>
                                            <td>{resolveTxnType(transaction.type)}</td>
                                            <td>{transaction.description} <br/> {resolveTxnDescription(transaction)}</td>
                                            <td className={transaction.amount > 0 ? cabinetStyle.transactionAmountCellPositive : cabinetStyle.transactionAmountCellNegative}>
                                                {transaction.amount}
                                                <div className={cabinetStyle.coinSmall}/>
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MentorCabinetTransactions